import { getStore } from '~/mobx/AppStore';

const getIsStandAdmin = () => {
    const { ballotStore } = getStore();
    return ballotStore.standAdminId !== undefined || ballotStore.standAdminLoginError !== '';
};

export default getIsStandAdmin;
